import { S_permiso_primitivo } from './../../../models/s_permiso_primitivo.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';



@Component({
    selector: "page-s_permiso_primitivo",
    templateUrl: "./s_permiso_primitivo.component.html", 
    providers: [FormService]
})

export class S_permiso_primitivoComponent {
    
    public rows = [];
      public actualRow;
      public s_permiso_primitivo: S_permiso_primitivo;
      public form;
      public fecha_permiso
      
      matcher = new FormService();
      

    constructor( public _formService: FormService){

        this.form = new FormGroup({
            cert_permiso: new FormControl('', Validators.required),
            fecha_permiso:new FormControl({value: '', disabled:true}, Validators.required)
        })

        if(!JSON.parse(localStorage.getItem("s_permiso_primitivo"))){
            localStorage.setItem("s_permiso_primitivo", JSON.stringify(this.rows));
        }else{
            
            this.rows = JSON.parse(localStorage.getItem("s_permiso_primitivo"));

            this.form.controls['fecha_permiso'].setValue(this.rows[0]?new Date(this.rows[0].fecha_permiso):null)
            this.form.controls['cert_permiso'].setValue(this.rows[0]?this.rows[0].cert_permiso:'')
            
            
        }

        
        

    }


    add_permiso( event?: MatDatepickerInputEvent<Date>, type?){

        if(event){
             this.fecha_permiso = moment(event.value).format('DD/MM/YYYY')
        } else {
            var temp = JSON.parse(localStorage.getItem("s_permiso_primitivo"))
            if(temp > 0){
                this.fecha_permiso = temp[0].fecha_permiso
            }else {
                this.fecha_permiso = ''
            }
            
        }
        localStorage.setItem("s_permiso_primitivo",JSON.stringify([]));
        this.actualRow = localStorage.getItem("s_permiso_primitivo");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            cert_permiso: this.form.value.cert_permiso,
            fecha_permiso: this.fecha_permiso
        })

        localStorage.setItem("s_permiso_primitivo", JSON.stringify(this.rows));
        this.form.reset();//

        //this.cip = JSON.parse(localStorage.getItem("cip"));

    }
    delete_permiso(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("s_permiso_primitivo", JSON.stringify(this.rows));
            }
        }
    }
}